import React from 'react';

/**
 * ScheduleViewTabs - Toggle between "My Schedule" and "Settings" views
 * Matches the pattern used in Dashboard, Polls, Watchlists tabs
 */
const ScheduleViewTabs = ({ 
  scheduleTabView, 
  setScheduleTabView 
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setScheduleTabView('calendar')}
        data-testid="schedule-calendar-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          scheduleTabView === 'calendar' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        My Schedule
      </button>
      <button
        onClick={() => setScheduleTabView('settings')}
        data-testid="schedule-settings-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          scheduleTabView === 'settings' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Settings
      </button>
    </div>
  );
};

export default ScheduleViewTabs;
